import { LauncherElement } from '../../types/launcherElement';

export const getElementById = (
  elements: LauncherElement[],
  id: string,
  parent: LauncherElement | null = null
): [LauncherElement | null, LauncherElement | null] => {
  for (let i = 0; i < elements.length; i++) {
    if (elements[i].id === id) return [elements[i], parent];

    const children = elements[i]?.props?.children;
    if (children && children.length) {
      const [foundElement, parent] = getElementById(children, id, elements[i]);
      if (foundElement) return [foundElement, parent];
    }
  }

  return [null, null];
};
